import $ from 'jquery'
import { BACKEND_URL } from '../config'
import { objectKeysToCamelCase } from './case-style-conversion'

export async function fetchFromBackend(relativeUrl, payload) {
  let response
  if (payload === undefined) {
    response = await $.getJSON({ url: `${BACKEND_URL}/${relativeUrl}` })
  } else {
    response = await $.post({
      url: `${BACKEND_URL}/${relativeUrl}`,
      data: JSON.stringify(payload),
      contentType: 'application/json'
    })
  }
  return objectKeysToCamelCase(response)
}
